export type RaceRule = { title: string; description?: string };

/** Structured rules are additive so already-released clients can still read `rules`. */
export const normalizeRaceRules = (value: unknown): RaceRule[] =>
  Array.isArray(value) ? value.flatMap((entry): RaceRule[] => {
    if (typeof entry === "string") return entry.trim() ? [{ title: entry.trim() }] : [];
    if (!entry || typeof entry !== "object" || typeof entry.title !== "string") return [];
    const title = entry.title.trim();
    const description = typeof entry.description === "string" ? entry.description.trim() : "";
    return title ? [{ title, ...(description ? { description } : {}) }] : [];
  }) : [];

export const getRaceRules = (race: { rules: string[]; ruleDetails?: RaceRule[] }): RaceRule[] =>
  normalizeRaceRules(race.ruleDetails ?? race.rules);

export const serializeLegacyRules = (rules: RaceRule[]): string[] =>
  rules.map(({ title, description }) => description ? `${title}\n${description}` : title);
